"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapBreadcrumbsFromBreadcrumbLinks = void 0;
const mapBreadcrumbsFromBreadcrumbLinks = (breadCrumbs)=>{
    var _breadCrumbs_links;
    const links = (_breadCrumbs_links = breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.links) !== null && _breadCrumbs_links !== void 0 ? _breadCrumbs_links : [];
    return links.map((link)=>{
        var _link_title, _link_relativeUrl;
        return {
            ItemLabel: (_link_title = link === null || link === void 0 ? void 0 : link.title) !== null && _link_title !== void 0 ? _link_title : '',
            Url: (_link_relativeUrl = link === null || link === void 0 ? void 0 : link.relativeUrl) !== null && _link_relativeUrl !== void 0 ? _link_relativeUrl : ''
        };
    });
};
exports.mapBreadcrumbsFromBreadcrumbLinks = mapBreadcrumbsFromBreadcrumbLinks;
